(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.searchModal = document.querySelector('search-modal');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.searchModal && this.searchModal.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      const modal = document.querySelector('search-modal');
      if (modal) modal.close();
    }
  }

  customElements.define('sticky-header', StickyHeader);


 


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-bulb-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('[data-bulb-track]');
    var prevBtn = document.querySelector('[data-bulb-prev]');
    var nextBtn = document.querySelector('[data-bulb-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var sl = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = sl <= 10;
      nextBtn.hidden = sl >= max - 10;
    }
    prevBtn.addEventListener('click', function() { track.scrollBy({ left: -240, behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function() { track.scrollBy({ left: 240, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-paired-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionId = "{{ section.id }}";
    var track = document.querySelector('[data-paired-track="' + sectionId + '"]');
    var prevBtn = document.querySelector('[data-paired-prev="' + sectionId + '"]');
    var nextBtn = document.querySelector('[data-paired-next="' + sectionId + '"]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var sl = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = sl <= 10;
      nextBtn.hidden = sl >= max - 10;
    }
    prevBtn.addEventListener('click', function() { track.scrollBy({ left: -240, behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function() { track.scrollBy({ left: 240, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-product-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('[data-cross-track]');
    var prevBtn = document.querySelector('[data-cross-prev]');
    var nextBtn = document.querySelector('[data-cross-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = scrollLeft <= 10;
      nextBtn.hidden = scrollLeft >= maxScroll - 10;
    }

    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -240, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: 240, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    /* Update on resize */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-whitestone-crosssell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.querySelector('[data-ws-track]');
    var prevBtn = document.querySelector('[data-ws-prev]');
    var nextBtn = document.querySelector('[data-ws-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateArrows() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = scrollLeft <= 10;
      nextBtn.hidden = scrollLeft >= maxScroll - 10;
    }

    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -260, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: 260, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
